
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import axios from "axios";
import "./Slidere.css";
import { useNavigate } from "react-router-dom";

const Slidere = () => {
   let navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanners = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/banner_list`
      );
console.log("Banner API response:", data.data)
      if (data?.result) {
        setBanners(data.data);
      } else {
        setError("No banner found");
      }
    } catch (err) {
      setError("Failed to load banners");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);
const settings = {
  className: "center-slider",
  centerMode: true,
  centerPadding: "0px",
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1800,
  speed: 900,
  cssEase: "cubic-bezier(0.45, 0, 0.15, 1)",
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  pauseOnHover: true,
  focusOnSelect: true,
  swipeToSlide: true,
responsive: [
  {
    // 700px se upar tak 3 cards (laptop + tablet)
    breakpoint: 1200,
    settings: { slidesToShow: 3, centerPadding: "0px" },
  },
  {
    // Phone: 1 card center me, dono side peek
    breakpoint: 700,
    settings: { slidesToShow: 1, centerPadding: "12%" },
  },
  {
    // Chhota phone
    breakpoint: 480,
    settings: { slidesToShow: 1, centerPadding: "8%" },
  },
],
};
  if (loading) return <p style={{ textAlign: "center" }}>Loading banners...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;

  // 🟢 NAYA: ab slug directly Store se aayega, hardcoded mapping ki zarurat nahi
  const handleCardClick = (item) => {
    const slug = item?.store_id?.slug;
    if (!slug) {
      console.warn("Is banner ke store ka slug nahi mila:", item?._id);
      return;
    }
    navigate(`/stores/${slug}`);
  };

  return (
    <div style={{ position: "relative", zIndex: 0 }}>
      <div className="maintext">
        <Slider {...settings}>
          {banners?.map((item, index) => (
            <div className="banner-slide-item" key={index}
     onClick={() => handleCardClick(item)}
     style={{ cursor: "pointer" }}
            >
              <img
                className="bannerimg"
                src={`${process.env.REACT_APP_API}uploads/${item.banner_image}`}
                alt={`Banner ${index + 1}`}
               onError={(e) => {
  e.target.onerror = null;
  e.target.src = "/fallback-banner.jpg";
}}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Slidere;